import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { environment } from './../../../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class PreventiveMaintenanceDetailService {
    private urlPrefix: string = environment.appUrl;
    constructor(
        private http: Http,
        private httpClient: HttpClient
    ) { }

    getDetail(id): Observable<any> {
        const url = this.urlPrefix + 'pms/' + id  ;
        return this.httpClient
            .get(url,
                {
                    observe: 'response'
                })
            .map(
                res => {
                    if (res.status === 200) {
                        return res.body;
                    } else {
                        return Observable.throw(null);
                    }
                }
            )
            .catch(
                err => {
                    return Observable.throw(err);
                }
            );
    }
    getCoverSheet(coverSheetId): Observable<any> {
        const url = this.urlPrefix + `forms/coversheet/${coverSheetId}/overview/pdf`;

        return this.httpClient.get(url, {
          observe: 'response',
          responseType: 'blob'
        })
        .map(res => {
          if (res.status === 200) {
            return {
              file: res.body,
              fileName: res.headers.get('content-disposition').replace('attachment;filename=', '')
            };
          } else {
            return Observable.throw(null);
          }
        })
        .catch(err => {
          return Observable.throw(err);
        });
      }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/preventive-maintenance/preventive-maintenance-detail/preventive-maintenance-detail.service.ts